import { Separator } from '@synoptic/ui-kit/separator/separator.js';
import React, { Ref } from 'react';
import { LayoutCard } from '@/components/layout/card';
import { StreamPostCardSkeleton } from '@/components/stream-post-card/stream-post-card-skeleton';
import { skeletonFeed } from './stream-post-feed-skeleton.css';

export const StreamPostFeedSkeleton = ({
  ref,
  count = 5,
}: {
  ref?: Ref<HTMLDivElement>;
  count?: number;
}) => (
  <LayoutCard ref={ref} className={skeletonFeed}>
    {Array.from({ length: count }).map((_, idx) => (
      <React.Fragment key={idx}>
        {idx > 0 ? <Separator /> : null}
        <StreamPostCardSkeleton />
      </React.Fragment>
    ))}
  </LayoutCard>
);
